module.exports = __webpack_public_path__ + "static/img/fourteen.408edd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog/fourteen.png
// module id = Bfds
// module chunks = 0